/**
 * Gets the names of services from a list of categories and service IDs.
 * @param {Array<{ id: string, name: string, services: Array<{ id: string, name: string }> }>} categories
 * @param {string[]} serviceIds
 * @returns {string[]} names of services
 */
export const getServicesNames = (categories, serviceIds) => {
  const serviceLookup = new Map();

  for (const category of categories ?? []) {
    for (const service of category.services ?? []) {
      serviceLookup.set(service.id, service.name);
    }
  }

  const serviceNames = (serviceIds ?? []).map((id) => serviceLookup.get(id)).filter(Boolean);

  return serviceNames;
};
